import React from 'react'
import styled from 'styled-components'
import { experienceData } from '../DataSource/Data'

const Experience = ({item}) => {
  return (
    <Wrapper>
        <div className='block-container'>
            <div className='block'>
                <p className='institution'>{item.title}</p>
                <p className='company'>{item.companyName}</p>
                <p className='period'>{item.period}</p>
                <p className='period'>{item.location}</p>  
            </div>
            
            <ul>
                {item?.pointers.map((item)=> <li> <p className='pointers'>{item}</p></li>)}
                {/* <p className='skills'>Skill: React Native, React JS</p> */}
             </ul>
          
        </div>

    </Wrapper>

  )
}

const Wrapper =  styled.section`
/* width: 80%;
margin: auto; */
margin-top: 1rem;
ul{
  background-color: #f9dded;
background-image: linear-gradient(102deg, #f9dded 0%, #ffffff 100%);


border-radius: 0.5rem;
padding-top: 0.5rem;
padding-bottom: 0.5rem;
}
.pointers{
    font-size: small;
}

p{
  /* background-color: aqua; */
  margin: 0;
}
.institution{
  
  font-size: large;
  color: #D40B7E;
  

}
.company{
    font-size: small;
    margin: 0.1rem 0;
    color: #2B86C5;
}
.period{
  font-size: x-small;
  margin: 0.1rem 0;
}
.degree{
  font-size: medium;
}

/* margin-left: 20px; */
.block-container{
  position: relative;
  /* width: 80%; */
  /* background-color: red; */

  border-left: 2px solid #D40B7E;
  display: grid;
  grid-template-columns: 14rem auto;

}

.block{
  margin-left: 2rem;
  /* padding-bottom: 1rem;
  padding: 1rem; */
  /* background-color: aqua; */
 

}
.skills{
  font-size: x-small;
  font-weight: bold;
  padding-top: 0.5rem;
  /* color: #f5f2f2; */
}
@media (max-width: 500px) {

 .block-container{
    display: flex;
    flex-direction: column;
   
 }
 ul{
    background-color: white;
    background-image: linear-gradient(102deg, #ffffff 0%, #ffffff 100%);
 }
    
}


/* background-color: red; */
/*  */

`

export default Experience;